import { useEffect, useState } from 'react';

interface UseTimelineVisibleRangeOptions {
    zoomedIn?: boolean;
    siblingsVisible?: boolean;
    transitioning?: boolean;
    direction?: number | null;
    maxIndex?: number;
}

// Range of timeline pages that are rendered around the current one.
export default function useTimelineVisibleRange(
    timelineIndex: number,
    {
        zoomedIn = false,
        siblingsVisible = false,
        transitioning = false,
        direction = null,
        maxIndex = 0,
    }: UseTimelineVisibleRangeOptions = {},
): { start: number; end: number } {
    const [range, setRange] = useState({
        start: timelineIndex,
        end: timelineIndex + (!zoomedIn && siblingsVisible ? 1 : 0),
    });

    let visibleBefore = 0;
    if (!zoomedIn) {
        visibleBefore = 1;
    } else if (zoomedIn && transitioning && direction === -1) {
        visibleBefore = 1;
    }
    let visibleAfter = 0;
    if (!zoomedIn) {
        visibleAfter = 1;
    } else if (zoomedIn && transitioning && direction === 1) {
        visibleAfter = 1;
    }
    const newStart = Math.max(0, timelineIndex - visibleBefore);
    const newEnd = Math.min(maxIndex, timelineIndex + visibleAfter);
    if (!siblingsVisible && (range.start !== newStart || range.end !== newEnd)) {
        setRange({
            start: newStart,
            end: newEnd,
        });
    }
    return range;
}
